import { NgModule } from "@angular/core";
import { OfflinePipe } from "./offline-pipe/offline";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { LoadingComponentModule } from "../components/loading/loading.module";
import { SvgIconModule } from "../components/svg-icon";

import { OfflineComponent } from "./offline-components/offline.component";
import { OfflineSwitchComponent } from "./offline-components/offline-switch.component";

@NgModule({
    declarations: [
        OfflinePipe,
        OfflineComponent,
        OfflineSwitchComponent
    ],
    exports: [
        OfflinePipe,
        OfflineComponent,
        OfflineSwitchComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        LoadingComponentModule,
        SvgIconModule
    ],
    providers: []
})
export class OfflineModule { }
